import React from "react";
import { Item, MenuItem } from "../../../../components/Menu";
import { LocalizationMessages } from "../../../../localization/messages";
import { UISelectors } from "../../../../redux/selectors";
import { UrlUtils } from "../../../../utils";
import { useCommunicationHandlers } from "../../../UsefulLinks";
import { useSelector } from "react-redux";
import { useFeature } from "../../../../hooks/useFeature";
import { AppFeatures } from "../../../../constants/featureFlags";

export const ContactUsMenuItem = () => {
  const isCustomerRelationsActive = useFeature(AppFeatures.CUSTOMER_RELATIONS);
  const links = useSelector(UISelectors.links);
  const { handleContactUs } = useCommunicationHandlers();
  const contactUsItem = new Item({
    URL: !isCustomerRelationsActive
      ? UrlUtils.getNativeLink(links.contactUs)
      : undefined,
    title: LocalizationMessages.contactUs,
    iconKey: "email",
    target: "SendEmailTab"
  });

  return (
    <MenuItem
      item={contactUsItem}
      dataTestId="uc-contact-us"
      ignoreNavigation={true}
      onClick={isCustomerRelationsActive ? handleContactUs : undefined}
      className={"userarea-section-links-last"}
    />
  );
};
